import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { WindowRefService } from '../../../../services/window-ref.service';
import { Store } from '@ngrx/store';
import { NotificationService } from '../../../../services/notification.service';
import { TokenExConfigResponse, VerficationResponse } from '../../../redirect/models/tokenex.model';
import { TokenExService } from '../../../redirect/services/tokenex.service';
import { clearAccounts, loadAccounts } from '../../../accounts/store/accounts.action';
import { FormTracking } from '../../../../config/eev-form-tracking.config';
import { AuthFormName, AuthFormType, AuthFormFieldName } from '../../../../enums/event/event-data.enum';
import { AuthEventType } from '../../../../enums/event/event.enum';
import { FormSubmit, FieldError } from '../../../../models/event-data.model';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { CommonModule } from '@angular/common';
import { IconCloseComponent } from '../../../shared/components/icon-close/icon-close.component';

interface ModalData {
  lastFourCardNumber: string;
  idToken: string;
}

@Component({
    selector: 'app-hub-card-verification-modal',
    templateUrl: './hub-card-verification-modal.component.html',
    styleUrls: ['./hub-card-verification-modal.component.scss'],
    imports: [MatDialogModule, CommonModule, IconCloseComponent]
})
export class HubCardVerificationModalComponent implements OnInit {
  public iframe;
  public tokenExConfig;
  public tokenExErrors: string;
  public isMatch: boolean;
  isLoading: boolean;

  constructor(
    private readonly notificationService: NotificationService,
    private readonly store: Store,
    private readonly tokenExService: TokenExService,
    private readonly eventTrackingService: EventTrackingService,
    private readonly windowRefService: WindowRefService,
    public dialogRef: MatDialogRef<HubCardVerificationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: ModalData
  ) {
    this.isLoading = true;
  }

  ngOnInit() {
    const matDialogConfig = new MatDialogConfig();
    this.dialogRef.addPanelClass('cdk-panel-custom');
    this.dialogRef.addPanelClass('cdk-panel-custom--dynamic');
    this.dialogRef.updatePosition(matDialogConfig.position);
    this.tokenExService.getAuthenticationKey(this.modalData.idToken).subscribe((config: TokenExConfigResponse) => {
      this.tokenExConfig = this.tokenExService.tokenExConfigMapper(config);
      this.iframe = new this.windowRefService.nativeWindow.TokenEx.Iframe('tokenExIframeDiv', this.tokenExConfig);
      this.iframe.load();
      this.iframe.on('load', () => {
        this.isLoading = false;
      });
      this.iframe.on('validate', (data) => {
        if (data.isValid) {
          this.tokenExErrors = null;
        } else {
          this.tokenExErrors = 'Please provide a valid 16 digit number';
        }
      });
      this.iframe.on('tokenize', (data) => {
        this.isLoading = true;
        this.tokenExService.validateCardAccount(data, this.modalData.idToken).subscribe(
          (response: VerficationResponse) => {
            this.isLoading = false;
            this.isMatch = response.matches;
            if (this.isMatch) {
              this.notificationService.displayInfo('Your card has been verified.');
              this.eventTrackingService.trackEvent<FormSubmit>(
                AuthEventType.FORM_SUBMIT,
                FormTracking[AuthFormName.CARD_SECOND_LEVEL_VERIFICATION].formSubmitEvent
              );
              this.dialogRef.close();
            } else {
              this.tokenExErrors = 'Mismatch. Please double check your input.';
              this.eventTrackingService.trackEvent<FieldError>(AuthEventType.FIELD_ERROR, {
                authFormName: AuthFormName.CARD_SECOND_LEVEL_VERIFICATION,
                authFormType: AuthFormType.CARD_SECOND_LEVEL_VERIFICATION,
                authFormFieldName: AuthFormFieldName.CARD_VERIFICATION_NUMBER,
                authFormFieldErrorMessage: 'Card 16 digit account number mismatch',
              });
            }
          },
          (error) => {
            this.isLoading = false;
            console.error(error);
          }
        );
      });
    });
  }

  ngOnDestroy(): void {
    this.store.dispatch(clearAccounts());
    this.store.dispatch(loadAccounts());
  }

  onVerify() {
    this.iframe.tokenize();
  }
}
